<template>
	<div class="number-bars" :class="theClass">
		<div class="number-bars__title" v-html="title"></div>
		<div class="number-bars__unit" v-html="unit"></div>
		<div class="number-bars__number">
			<Counter :number="numbers[0].value" :options="numbers[0].options" />
		</div>
		<div class="number-bars__items">
			<div class="number-bars__item" :class="`number-bars__item-${key}`" :key="key" v-for="(number, key) in numbers" :data-value="format(number.value, number.options)">
				<div class="number-bars__item-label">
					{{ number.label }}
					<span class="number-bars__item-digit">
						<Counter :number="number.value" :options="number.options" />
					</span>
				</div>
				<div class="number-bars__item-value" :style="{width: barWidth(number, numbers)}" :title="number.value">
					<div class="number-bars__item-value-track"></div>
				</div>
			</div>
		</div>
		<div class="number-bars__scale" v-if="!mini">
			<div class="number-bars__scale-item" v-for="(num, idx) in numbersScale">{{ num }}</div>
		</div>
	</div>
</template>

<script>
import Counter from '@/components/Counter.vue'

export default {
	name: 'NumberBars',
	components: {
		Counter,
	},
	props: {
		title: String,
		subtitle: String,
		unit: String,
		numbers: Array,
		mini: false,
		barClass: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		bounding: {},
		viewed: false,
	}),
	mounted() {
		window.addEventListener('smoothScroll', this.onScroll, { passive: true })
	},
	unmounted() {
		window.removeEventListener('smoothScroll', this.onScroll)
	},
	computed: {
		theClass() {
			return {
				[this.barClass]: true,
				mini: this.mini,
				viewed: this.viewed,
			}
		},
		numbersScale() {
			const numbers = []
			const max = Math.max(...this.numbers.map(n => n.value))
			const int = Number(max) / 4
			const [num] = this.numbers
			const {prefix = ``, decimalPlaces = 0} = num.options
			for (let i = 0; i < this.numbers.length; i++) {
				const v = Math.floor(i * int)
				numbers.push( this.format(v, this.numbers[0].options) )
				// numbers.push( prefix +''+ v.toFixed(decimalPlaces) )
			}
			numbers.push(this.format(max, this.numbers[0].options) )
			// numbers.push(prefix +''+ max.toFixed(decimalPlaces))
			return numbers
		},
	},
	methods: {
		onScroll(evt) {
			const elBounds = this.$el.getBoundingClientRect()
			const { bottom, left, right, top, width: elWidth } = elBounds
			const { height, width, } = evt.detail.bounds
			if (left >= 0 && top >= 0 && bottom <= height && (right - elWidth) <= width ) {
				this.viewed = true
				window.removeEventListener('smoothScroll', this.onScroll)
			}

		},
		barWidth(number, numbers) {
			const max = numbers.reduce((a, b) => Math.max(a, b.value), 0)
			return ((number.value || 0) / (max || 1) * 100) + '%'
		},
		scales(numbers) {
			const scales = []
			const dec = (numbers[0].options || {}).decimalPlaces || 0
			const num = numbers.reduce((a, b) => Math.max(a, b.value), 0)
			const base = num / 4
			for (let i = 0; i <= 4; i++) {
				scales.push(((base * i) / 1).toFixed(dec))
			}

			return scales
		},
		format(value, options = {}) {
			return (options.prefix || '') + (new Intl.NumberFormat().format(value))
		},
	},
}
</script>

<style scoped lang="scss">
.number-bars {
	--color--highlight: var(--number-color, white);

	color: var(--color--cream);
	display: flex;
	flex-direction: column;
	height: 100%;
	text-align: left;
	width: 96%;

	&__title {
		font-family: var(--font-family--sans);
		font-size: 1.25rem;
		font-weight: 400;
		line-height: 0.95;
		letter-spacing: 0.025rem;
		margin-bottom: 0;
		margin-top: 0;
		text-transform: uppercase;

		> span {
			font-weight: 200;
		}

		.home & {
			font-size: var(--font-caption--size);

			@include modules.media-query('phone') {
				font-size: var(--font-caption--size--mobile);
			}
		}

	}

	&__unit {
		font-family: var(--font-family--sans);
		font-size: 1rem;
		font-size: clamp(7px, 2.1vw, 1rem);
		font-weight: 300;
		text-transform: uppercase;
		line-height: 1.1875;
		margin-top: 0;
		margin-bottom: 1rem;

		.mini & {
			margin-bottom: 0;
			font-size: 14px;
			font-size: clamp(7px, 2.1vw, 14px);
			font-weight: 200;
		}
	}

	&__number {
		color: var(--color--cream);
		font-family: var(--font-family--label);
		font-size: 4rem;
		font-size: clamp(8px, 4.4vw, 4rem);
		font-weight: 400;
		text-transform: uppercase;
		margin-top: auto;
		height: 4.5rem;
		line-height: 1;

		.mini & {
			height: auto;
		}

		.content-box & {
			color: var(--number-color);
		}

		@include modules.media-query('phone') {
			font-size: 4rem;
			font-size: clamp(32px, 8.8vw, 64px);
		}

		// @media (max-width: 1220px) {
		// 	font-size: 3rem;
		// }

		// @media (max-width: 1120px) {
		// 	font-size: 2.5rem;
		// }

		// @media (max-width: 980px) {
		// 	font-size: 2rem;
		// }

		// @media (max-width: 960px) {
		// 	font-size: 1.5rem;
		// }
	}

	&__item {
		font-family: var(--font-family--sans);
		font-size: 1.25rem;
		font-size: clamp(8px, 1.38vw + 1rem, 1.25rem);
		margin-bottom: 0.5rem;
		padding: 0.5rem 1rem;
		position: relative;
		text-align: left;

		@include modules.media-query('phone') {
			margin-bottom: 0.1rem;
		}

		.home & {
			font-size: var(--font-author--small);
			font-size: clamp(8px, 1.38vw + 1rem, 1.25rem);

			@include modules.media-query('phone') {
				font-size: clamp(7px, 1.92vw, 1.25rem);
				// font-size: 8px;
				// padding: 0.25rem 0.5rem;
				// font-size: var(--font-author--small--mobile);
			}
		}

		.mini & {
			padding: 0.35rem 1rem;

			@include modules.media-query('phone') {
				margin-bottom: 0.1rem;
				padding: 0.25rem 1rem;
			}
		}

		&:last-of-type {
			margin-bottom: 0;
		}

		&-label {
			color: var(--color--dark-green);
			font-weight: 500;
			position: relative;
			z-index: 3;

			.home & {
				font-weight: 400;
			}
		}

		&:hover {
			.number-bars__item-digit {
				opacity: 1;
				transform: translateX(0);
			}
		}

		&-0 {
			.number-bars__item-label {
				color: var(--color--cream);
			}

			.number-bars__item-digit {
				background-color: var(--color--dark-green);
				color: var(--color--cream);

				&:after {
					border-top-color: var(--color--dark-green);
				}
			}

			.number-bars__item-value-track {
				background-color: var(--color--highlight);
			}
		}

		&-digit {
			font-weight: 300;
			font-size: 1.1rem;
			position: absolute;
			margin-left: 1rem;
			background-color: var(--color--dark-green);
			color: var(--color--cream);
			padding: 0.25rem 0.5rem;
			margin-top: -0.15rem;
			opacity: 0;
			transform: translateX(0.5rem);
			transition: all 250ms ease-out;
			will-change: transform;

			.home & {
				margin-top: -.3rem;
			}

			&:after {
				content: '';
				width: 0;
				height: 0;
				border: 5px solid transparent;
				border-top-color: var(--color--hunter-green);
				left: -10px;
				top: 50%;
				transform: rotate(90deg) translateX(-50%);
				position: absolute;
			}
		}

		&-value {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			height: 100%;
			top: 0;
			left: 0;
			position: absolute;
			z-index: 2;

			&-track {
				background-color: var(--color--cream);
				border-radius: 3.75rem;
				height: 100%;
				transition: width 2000ms ease-out 100ms;
				width: 0;

				.viewed & {
					width: 100%;
				}
			}
		}
	}

	&__scale {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 0.75rem 0.5rem 0 0.5rem;
		margin-top: 1rem;
		border-top: 1px solid var(--color--hunter-green);
		font-family: var(--font-family--sans);
		font-size: 1.25rem;
		font-weight: 200;
	}
}


.number-bars__item-0 {
	.number-bars__item-value-track {
		.bar-orange & {
			background-color: var(--color--orange);
		}
		.bar-gold & {
			background-color: var(--color--gold);
		}
		.bar-mint & {
			background-color: #99B5AA;
		}
	}

	.number-bars__item-label {
		.bar-orange & {
			color: var(--color--cream);
		}

	}
}

.number-bars__item-1 {
	.number-bars__item-value-track {
		.bar-mint & {
			background-color: var(--color--mint);
		}
	}
}

.number-bars__item-2 {
	.number-bars__item-value-track {
		.bar-mint & {
			background-color: var(--color--mint);
		}
	}
}
</style>
